import { render } from "./TrackShipment.vue?vue&type=template&id=689c27f2"
import script from "./TrackShipment.vue?vue&type=script&lang=js"
export * from "./TrackShipment.vue?vue&type=script&lang=js"

import "./TrackShipment.vue?vue&type=style&index=0&id=689c27f2&lang=css"

import exportComponent from "D:\\Code Backup\\ts-web-old\\TatSingGroup-Web\\ts-logistics-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__